export default __webpack_public_path__ + "static/media/Network_1.467cb07d.svg";